<template>
    <div :id="id" element="TextComponent" class="sitebuilder-element-container"
         :style="style()"
         :data-tag="dataTag()"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile"
         :data-editing="this.editing">


        <!--      <div v-html="internal_config.order_mobile" style="text-align: center"></div>-->

        <span class="sitebuilder-element desktop-element" v-show="!this.editing"
              :style="'font-size: '+ internal_config.fontSize + ' !important;font-weight: '+ internal_config.weight "
              v-html="internal_config.content"></span>
        <span class="text-center-sb sitebuilder-element mobile-element"
              :style="'font-size: '+ internal_config.fontSizeMobile + ' !important;font-weight: '+ internal_config.weight + ';'"
              v-html="internal_config.content"></span>
    </div>
</template>

<script>

	import TextData from './Model';
	import Resources from './Resources.vue';

	export default {
		name: 'TextComponent',
		props: ['config', 'id', 'preview'],
		components: {
			TextData,
			Resources
		},
		data() {
			return TextData.data();
		},
		methods: {
			dataTag(){
				if (this.internal_config.tag) {
					return this.internal_config.tag;
				}
				return '';
			},
			fontSizeMobileChange() {

				let elements = document.getElementById(this.$el.id).querySelectorAll('.mobile-element p,.mobile-element span,.mobile-element h1,.mobile-element h2,.mobile-element h3,.mobile-element h4,.mobile-element h5,.mobile-element h6,.mobile-element ul,.mobile-element em,.mobile-element ol,.mobile-element li,.mobile-element big,.mobile-element small');

				for (var i in elements) {
					$(elements[i]).css({'font-size': parseInt(this.internal_config.fontSizeMobile) + 'px'});
				}
			},


			build(config) {
				this.internal_config = config;
				this.internal_config.content = this.internal_config.content.replace(/&nbsp;/g, ' ');
			},

			style() {
				return `width: ${this.internal_config.width};
                left:  ${this.internal_config.left};
                padding-top: ${this.internal_config.paddingTop};
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                     z-index: ${this.internal_config.zIndex};
                padding-bottom: ${this.internal_config.paddingBottom};
                top: ${this.internal_config.top}`;
			}
		},
		mounted() {
			this.build(this.$props.config);

			Object.keys(this.props).forEach(prop => {
				if (typeof this.internal_config[prop] === 'undefined') {
					this.internal_config[prop] = this.props[prop];
				}
			});

			this.fontSizeMobileChange();

			this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @media (max-width: 980px) {
        .desktop-element {
            display: none !important;
        }

        .mobile-element {
            display: block !important;
        }
    }

    @media (min-width: 981px) {
        .desktop-element {
            display: block !important;
        }

        .mobile-element {
            display: none !important;
        }
    }

    .auto-height {
        height: auto !important;
    }

    .text-center-sb {
        text-align: center;
    }

</style>

